export default async function ({ app, route, localePath, redirect }) {
    // console.log('da', route.fullPath.substring(0, 3).includes(`${app.i18n.defaultLocale}`));
    // if (route.fullPath.substring(0, 3).includes(`${app.i18n.defaultLocale}`)) {
    //     return redirect(localePath(route.fullPath.replace(`/${app.i18n.defaultLocale}`, '')));
    // }
}
